import { useImageAnnotatorContext } from "@msuite/image-annotator";
import type { DimensionAnnotation } from "@msuite/utils/types";
import { useTranslation } from "../../../localization";
import { Slider } from "../../../slider";

export function AnnotationToolbarSubMenuOffset() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as DimensionAnnotation;

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<div className="flex flex-col gap-1">
			<div className="flex flex-row justify-between items-center **:text-white! text-xs">
				<p>{t("image_annotator.offset")}</p>
				<p>{selectedAnnotation.offset.toFixed(2)}px</p>
			</div>
			<Slider
				className="w-full"
				min={-100}
				max={100}
				value={[selectedAnnotation.offset || 0]}
				onChange={([value]) => context.controller.handleOnUpdateSelection({ offset: value })}
			/>
		</div>
	);
}
